<template>
  <div>40444444444</div>
</template>
<script>
export default {
  name: '404',
};
</script>
